export class ChronosActivitiesModel {
	ActivityID: number = null;
	JobID: number = null;
	ActivityTypeID: number = null;
	Description: string = "";
	TriggerOrder: number = 0;
	MaxRepeatCount: number = null;
	RepeatDelayMinutes: number = null;
	Details: any;
	PostActivities: any;
	ActivityLastModifiedTime: Date;
	ActivityLastModifiedBy: string = "";

	constructor() {
		this.Details = {};
	}
}

export class InterfaceJobDetails {
	ActivityID: number = null;
	BankID: number = null;
	Download: boolean = false;
	DownloadDirectory: string = "";
	ImportHoldings: boolean = false;
	ImportTransactions: boolean = false;
	ImportSecurities: boolean = false;
	ImportSecurityPrices: boolean = false;
	ImportExchangeRates = false;
	ImportClients: boolean = false;
	ImportAccounts: boolean = false;
	ImportRatings: boolean = false;
	Process: boolean = false;
	UnzipPriorToImport: boolean = false;
}

export class ReportJobDetails {
	ActivityID: number = null;
	OptionID: number = null;
	FilterID: number = null;
	ExportDirectory: string = "";
	IsExport: boolean = false;
	ReportSubID: number = null;
}

export class ImportJobDetails {
	ActivityID: number = null;
	ImportID: number = null;
	DownloadDirectory: string = "";
	DownloadURL: string = "";
}

export class ProcessJobDetails {
	ActivityID: number = null;
	ProcessID: number = null;
	ExportDirectory: string = "";
}

export class EmailJobDetails {
	ActivityID: number = null;
	EmailAddress: string = "";
	Subject: string = "";
	MessageText: string = "";
	AttachementFileName: string = "";
}

export class SMSJobDetails {
	ActivityID: number = null;
	PhoneNumber: string = "";
	MessageText: string = "";
}

export class TaskActivityDetails {
	ActivityID: number = null;
	AssignedUserID: number = null;
	SecAssignedUserID: number = 0;
	isPrivate: boolean = false;
	TaskPriority: string = "";
	Text: string = "";
	DueDate: Date;
	Notes: string = "";
	AwaitTaskCompletion: boolean = false;
	DueTime: number = null;
	AssignedUserList: [] = [];
}

export class ObjectCreationNotifierDetails {
	ActivityID: number = null;
	MonitoringObjectTypeID: number = null;
}

export class ReportDetails{
	CollectionID: number = null;
	ReportID: number = null;
	ReportName: string = "";
	Show: boolean = false;
}

export class SubReportDetails{
	CollectionID: number = null;
	ReportID: number = null;
	Show: boolean = false;
	ReportSubID: number = null;
	ReportPrint: boolean = false;
	ReportName: string = "";
}




// WEBPACK FOOTER //
// ./app/insa-models/chronos-activities-model.ts